import type { ReactNode } from 'react';

import type { LucideIcon } from '../../../../common/icons/lucide-adapter';
import { ctw } from '@/common';
import { CopyButton } from '@/components';

export type DataRowProps = {
  label: string;
  Icon?: LucideIcon;
  value: ReactNode;
  copyable?: boolean;
  copyValue?: string;
  emptyLabel?: string;
  className?: string;
  disableTranslation?: boolean;
  dataTestId?: string;
};

export const DataRow: React.FC<DataRowProps> = ({
  label,
  Icon,
  value,
  copyable = false,
  copyValue,
  emptyLabel = 'Not Detected',
  className,
  disableTranslation,
  dataTestId,
}) => {
  const hasValue =
    value !== null &&
    value !== undefined &&
    !(typeof value === 'string' && value.trim().length === 0);

  return (
    <div className={ctw('mb-4 grid grid-cols-2 items-center', className)}>
      <div className="flex items-center gap-2">
        {Icon && <Icon className="h-4 w-4 text-zinc-500" />}
        <p className="mb-1 text-sm text-slate-400">{label}</p>
      </div>
      <div className="flex items-center gap-2">
        <div
          className={ctw('text-sm', {
            'truncate text-gray-900': hasValue,
            'text-slate-400': !hasValue,
            notranslate: disableTranslation,
          })}
          {...(disableTranslation && { translate: 'no' })}
          {...(dataTestId && { 'data-testid': dataTestId })}
        >
          {hasValue ? value : emptyLabel}
        </div>
        {hasValue && copyable && copyValue && <CopyButton textToCopy={copyValue} />}
      </div>
    </div>
  );
};
